<template>
  <section class="l-content-area">
    <div class="l-content l-content--reservation">
      <div class="l-wrap__outer">
        <div class="l-wrap__inner">
          <section class="c-title__bloc c-title__bloc--reservation">
            <h1>新規来店予約申し込み登録</h1>
            <div class="c-btn c-btn--title-back"><a href="#" @click="prevToStep()">戻る</a></div>
          </section>

          <section class="p-bloc p-bloc__reservation">
            <h2 class="p-reservation__step">STEP 3</h2>

            <div class="p-reservation__bloc">
              <p>ご希望の施術内容を選択してください。</p>

              <div
                v-for="(treatment, index) in listTreatment"
                :key="index"
                class="p-reservation__service"
                :value="index + 1"
              >
                <div class="c-service__bloc">
                  <ul class="tag">
                    <li class="c-tag">
                      <span>{{ treatment.service }}</span>
                    </li>
                    <li v-if="treatment.isFree" class="c-tag c-tag--free">
                      <span> {{ treatment.symbol }}</span>
                    </li>
                  </ul>
                  <div v-if="treatment.category === 'cut'">
                    <a href="#" @click.prevent="nextToStepDesignCut()">
                      <h2>{{ treatment.name }}</h2>
                      <p>{{ treatment.description }}</p>
                    </a>
                  </div>
                  <div v-else-if="treatment.category === 'con'">
                    <a href="#" @click.prevent="nextToStepConclusion()">
                      <h2>{{ treatment.name }}</h2>
                      <p>{{ treatment.description }}</p>
                    </a>
                  </div>
                  <div v-else>
                    <a href="#" @click.prevent="nextToStep(treatment.id)">
                      <h2>{{ treatment.name }}</h2>
                      <p>{{ treatment.description }}</p>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <button-registration
              :prev-text="'戻る'"
              :handle-prev-button="prevToStep"
              :is-next-button="false"
              :prev-text-color="'#787878'"
            ></button-registration>
          </section>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import ButtonRegistration from '../common/ButtonRegistration'
import { listTreatment } from '../../constant/listTreatment'

export default {
  name: 'ReservationInfo',
  components: { ButtonRegistration },
  props: {
    currentStep: {
      type: String,
      default: '3',
    },
    studio: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isSubTreatment: 0,
      listTreatment,
    }
  },
  methods: {
    prevToStep() {
      this.$emit('prevToStep')
    },
    nextToStep(value) {
      this.$emit('onChangeDesignCut', false)
      this.$emit('onChangeConclusion', false)
      this.$emit('nextToStep', [value])
    },
    nextToStepDesignCut() {
      this.$emit('onChangeDesignCut', true)
      this.$emit('onChangeConclusion', false)
      this.$emit('nextToStep', [])
    },
    nextToStepConclusion() {
      this.$emit('onChangeConclusion', true)
      this.$emit('onChangeDesignCut', false)
      this.$emit('nextToStep', [])
    },
  },
}
</script>

<style scoped>
.v-application ul,
.v-application ol {
  padding-left: 0 !important;
}

.v-application a {
  color: #0a005a;
}
</style>
